module.exports = __webpack_public_path__ + "img/IMG_6258_L_WoodMatted.b71c5035.jpg";